import React from 'react';
import cn from 'classnames';
import { useRouter } from 'next/router';
import { toSlug } from '@framework/url/helpers/toSlug';
import pageStyles from '@framework/global-styles/page.module.scss';
import interactionStyles from '@creditflowresearch/uilib/styles/helpers/interaction.module.scss';
import { IAssetClass } from '@/creditflowresearch/domain/vo/IAssetClass';

interface IProps {
  assetClassCollection: Array<IAssetClass>,
  isAllDisabled: boolean,
  handleAssetClassClick: (e) => void,
}

const BaseAssetClasses = ({
  assetClassCollection,
  isAllDisabled,
  handleAssetClassClick,
}:IProps) => {
  const { query: { assetClass: routeAssetClass } }: any = useRouter();
  return (
    <>
      { assetClassCollection
        .filter((assetClass) => assetClass.active)
        .map((assetClass) => {
          if (
            (
              (!Number.isInteger(assetClass.totalBwic) && !Number.isInteger(assetClass.totalInventory)) ||
              (assetClass.totalBwic > 0 || assetClass.totalInventory > 0)
            ) &&
            !isAllDisabled
          ) {
            return (
              <a
                onClick={ () => handleAssetClassClick(assetClass) }
                key={ assetClass.id }
                className={ cn({
                  [pageStyles.isActiveNavLink]: routeAssetClass === toSlug(assetClass.abbreviation),
                }) }
                data-test={ assetClass.name }
              >
                <span>{ assetClass.name }</span>
              </a>
            );
          }
          return (
            <a
              key={ assetClass.id }
              className={ cn(pageStyles.isDisabledNavLink, interactionStyles.cursorDefault) }
            >
              { assetClass.name }
            </a>
          );
        }) }
    </>
  );
};

export default BaseAssetClasses;
